<script>
import gaFilterComponentMixin from '@mixins/gaFilterComponentMixin';
import GaBaseExpandedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseExpandedFilter.vue';
import GaBaseFoldedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseFoldedFilter.vue';
import {useCompanyStore} from '@store/companyStore';
import Checkbox from 'primevue/checkbox';
import offerTypesConst from '@mixins/const/offerTypesConst';

export default {
  name: 'GaFilterOffer',
  components: {GaBaseFoldedFilter, GaBaseExpandedFilter, Checkbox},
  mixins: [gaFilterComponentMixin, offerTypesConst],
  data() {
    return {
      optionValueProperty: 'value',
      optionLabelProperty: 'label',
    };
  },
  mounted() {
    this.options = this.offerTypesConst;
  },
};
</script>

<template>
  <template v-if="isVisible">
    <GaBaseFoldedFilter
      v-if="!isExpanded"
      title="Formule"
      @click="onClick"
      :icon="hasIcon ? 'ga-residence-principale' : null"
      :subtitle="subtitle"
      :nb-selected="nbSelected" />
    <GaBaseExpandedFilter
      v-else
      title="Formule"
      :nb-selected="nbSelected"
      :can-go-back="canGoBack"
      :options-count="options.length"
      show-select-all
      @apply="apply"
      @reset="reset"
      @back="back"
      @toggle-select-all="toggleSelectAll">
      <div class="flex flex-col gap-1 px-3.5 py-3">
        <div v-for="option in options" :key="option.value" class="py-1.5 px-3 w-full">
          <label class="gap-3 flex px-2 py-1 items-center cursor-pointer">
            <checkbox
              v-model="currentFilter.value"
              :value="option.value"
              class="[&_.p-checkbox-box]:!border-grey [&_.p-checkbox-box]:border [&_.p-checkbox-box]:rounded-6"
              :class="{
                '[&_.p-checkbox-box]:!bg-primary [&_.p-checkbox-box]:border-0': currentFilter.value.includes(
                  option.value,
                ),
              }" />
            <span class="font-medium text-grey-900 select-none">
              {{ option.label }}
            </span>
          </label>
        </div>
      </div>
    </GaBaseExpandedFilter>
  </template>
</template>

<style scoped></style>
